import React from "react";

function SelectCountry({
  selectCountry,
  setSelectCountry,
  countries,
  propswidth,
  formFieldColor,
  propsStyle,
}) {
  const handleChange = (event) => {
    setSelectCountry(event.target.value); // 상태 업데이트
    console.log(selectCountry);
  };

  return (
    <div
      className={`formField customSelectWrapper ${formFieldColor || "white"}`}
      style={{ width: propswidth, ...propsStyle }}
    >
      <select id="select-country" value={selectCountry} onChange={handleChange}>
        <option value="">{"선택"}</option>
        {countries.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectCountry;
